<template>
    <span
        class="badge"
        :style="{
        backgroundColor: bus.color_code,
        color: invertHex(bus.color_code),
        }">
            {{ bus.name }}</span
    >
</template>

<script>
import utilsColors from "../../../../utils/colors";

export default {
    props: {
        bus: {
            type: Object,
            required: true,
        }
    },
    mixins: [utilsColors],
}
</script>